<template>
  <header class="head pa-0">
    <v-responsive max-width="1080" class="mx-auto">
      <div
        class="head-wrap pa-0"
        :style="{ background: $vuetify.theme.themes.light.background }"
      >
        <h1 class="logo">
          <a href="/" name="top" class="logo-cover">
            <span class="logo-img">
                    <img :src="`${cdnBaseUrl}/charibon/images/common/charibon-logo.svg`"
                         width="100%"
                         alt="" />
            </span>
          </a>
        </h1>
      </div>
    </v-responsive>
  </header>

</template>

<script>
export default {
  name: "charibon-header",
  data() {
    return {
      cdnBaseUrl: VueConfig.cdn_url.replace("/ws/site", "")
    }
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style scoped>
* {
  font-family: "メイリオ", Meiryo, "游ゴシック", "Yu Gothic", YuGothic, "Hiragino Kaku Gothic ProN", "Hiragino Kaku Gothic Pro", "ＭＳ ゴシック", sans-serif !important;
}

a {
  text-decoration: none;
  outline: none;
}

.head {
  width: 100%;
  height: auto;
}

.head-wrap {
  width: 100%;
  padding-bottom: 12px;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}

h1.logo {
  background: none;
  float: none;
  width: 172px;
  position: relative;
  padding-top: 21px;
  margin: auto;
}

.logo-cover {
  width: 172px;
}

.logo-catch {
  position: absolute;
  width: 500px;
  top: 1px;
  left: 0;
  display: inline-block;
  border: none;
  font-size: 10px;
  /*font-size: 1rem;*/
  padding: 0 0 5px;
  border-radius: 0;
  color: #111111;
}

.logo-img {
  border: none;
  /*display: inline-block;*/
  display: flex;
  padding: 0;
  border-radius: 0;
}

@media screen and (max-width: 767px) {
  .head {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 50;
  }

  .head-wrap {
    width: 100%;
    min-width: 100%;
  }

  h1.logo {
    width: 110px;
    height: 60px;
    padding-top: 10px;
  }

  .logo-cover {
    width: 100%;
    height: 100%;
  }

  .logo-catch {
    -webkit-box-ordinal-group: 3;
    -ms-flex-order: 2;
    order: 2;
    font-size: 10px;
    padding: 8px 0 0 15px;
    width: auto;
    position: relative;
    top: 0;
  }

  .logo-img {
    -webkit-box-ordinal-group: 2;
    -ms-flex-order: 1;
    order: 1;
  }
}
</style>